/* src/app/core/layout/components/toggler-view-type/toggler-view-type.component.scss */
/*# sourceMappingURL=toggler-view-type.component-24UII7IO.css.map */
